import { createContext, useContext, useMemo, useState } from "react";

const StoreInfosValueContext = createContext();
const StoreInfosActionsContext = createContext();

export function StoreInfosContextProvider({ children }) {
    const [storeInfos, setStoreInfos] = useState([]);

    const storeInfosActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setStoreInfos(newValues);
                },
                setValue: setStoreInfos
            }
        },
        []
    )

    return (
        <>
            <StoreInfosActionsContext.Provider value={{ storeInfos: storeInfosActions }}>
                <StoreInfosValueContext.Provider value={{ storeInfos }}>
                    {children}
                </StoreInfosValueContext.Provider>
            </StoreInfosActionsContext.Provider>
        </>
    );
}

export function useStoreInfosValueContextHook(props) {
    const value = useContext(StoreInfosValueContext);

    if (value === undefined) {
        throw new Error('useStoreInfosValueContextHook should be used within StoreInfosValueContext');
    }

    return {
        storeInfos: value.storeInfos,
    };
}

export function useStoreInfosActionsContextHook(props) {
    const value = useContext(StoreInfosActionsContext);

    if (value === undefined) {
        throw new Error('useStoreInfosActionsContextHook should be used within StoreInfosActionsContext');
    }

    return {
        storeInfos: {
            onSet: value.storeInfos.onSet,
            setValue: value.storeInfos.setValue
        },
    };
}